import { RiEyeFill } from '@remixicon/react';
import { Link } from 'react-router';
import { useLanguage } from '../contexts/language';
import { IconButton, SvgIcon, Tooltip } from '@mui/material';
import { SimpleSkeleton } from './SkeletonElements';

interface AdminTableDetailLinkProps {
  href: string;
  isLoading: boolean;
}

const AdminTableDetailLink = ({
  href,
  isLoading,
}: AdminTableDetailLinkProps) => {
  const { t } = useLanguage();
  return (
    <div className="inline-block relative">
      {isLoading && (
        <div className="absolute bottom-[50%] translate-y-[50%] right-0 left-0">
          <SimpleSkeleton />
        </div>
      )}
      <Link
        to={href}
        className={isLoading ? 'invisible pointer-events-none' : undefined}
      >
        <Tooltip title={t(`content.view`)}>
          <IconButton>
            <SvgIcon component={RiEyeFill} fontSize="small" />
          </IconButton>
        </Tooltip>
      </Link>
    </div>
  );
};

export default AdminTableDetailLink;
